export default {
  title: "Protocolli",
  subtitle: "PDF aziendali di riferimento per lo staff.",
  empty: "Nessun protocollo corrisponde a questi filtri.",
  emptyWritable: "Carica il primo protocollo PDF.",
  template: {
    download: "Scarica template",
  },
  filters: {
    searchPlaceholder: "Cerca per titolo",
    statusLabel: "Stato",
    statusAll: "Tutti gli stati",
    categoryLabel: "Categoria",
    categoryPlaceholder: "es. Device, Ops",
    tagLabel: "Tag",
    tagAll: "Tutti i tag",
    tagCount: "{{count}} selezionati",
  },
  tags: {
    label: "Tag",
    placeholder: "Seleziona o aggiungi tag",
    searchPlaceholder: "Cerca tag…",
    create: "Aggiungi “{{name}}”",
  },
  status: {
    ACTIVE: "Attivo",
    SUSPENDED: "Sospeso",
    OBSOLETE: "Obsoleto",
  },
  actions: {
    view: "Visualizza",
    download: "Scarica",
    edit: "Modifica",
    versions: "Versioni",
    addVersion: "Aggiungi nuova versione",
    markObsolete: "Segna obsoleto",
    more: "Altre azioni",
  },
  obsolete: {
    title: "Segnare il protocollo come obsoleto?",
    body: "“{{title}}” uscirà dall’elenco Attivi. La cronologia delle versioni resta; non si potranno pubblicare nuove versioni finché non torna Attivo.",
    confirm: "Segna obsoleto",
    success: "Protocollo segnato come obsoleto",
  },
  upload: {
    title: "Carica protocollo",
    titleLabel: "Titolo",
    titlePlaceholder: "es. Piano di evacuazione",
    categoryLabel: "Categoria",
    categoryPlaceholder: "es. Device",
    statusLabel: "Stato",
    fileLabel: "File PDF",
    dropzoneTitle: "Trascina un PDF qui, o clicca per scegliere",
    dropzoneDescription: "Solo PDF, max 20 MB",
    submit: "Carica",
    success: "Protocollo caricato",
  },
  edit: {
    title: "Modifica protocollo",
    submit: "Salva",
    success: "Protocollo aggiornato",
  },
  versions: {
    title: "Versioni — {{title}}",
    publishTitle: "Aggiungi nuova versione — {{title}}",
    current: "Corrente",
    loadError: "Impossibile caricare le versioni",
    bumpLabel: "Tipo di versione",
    bumpMinor: "Minore",
    bumpMinorDescription: "Piccoli aggiornamenti o correzioni.",
    bumpMajor: "Maggiore",
    bumpMajorDescription: "Riscrittura significativa o cambio di policy.",
    changeSummaryLabel: "Cosa è cambiato",
    changeSummaryPlaceholder: "Note opzionali su cosa è cambiato in questa versione…",
    changeSummaryHint: "Opzionale",
    submit: "Pubblica versione",
    success: "Nuova versione pubblicata",
    publishBlocked:
      "Riattiva questo protocollo (stato Attivo) prima di pubblicare una nuova versione.",
  },
  errors: {
    titleRequired: "Inserisci un titolo",
    fileRequired: "Scegli un file PDF",
    fileTooLarge: "{{name}} è troppo grande. Dimensione massima {{max}}.",
    loadError: "Impossibile caricare i protocolli",
  },
} as const;
